import { ButtonCheckbox } from '@/components/common/Button'
import { useFilterFormError } from '@/components/common/Filter'
import { CARD_FILTER_LABELS, type CardFilterBooleanPartialType, type CardFilterType } from '@/defs/cardFilters'

import styles from './GalleryCardFiltersFormBoolean.module.scss'

type Props = {
  cardFilter: CardFilterBooleanPartialType
  onDelete: () => void
  onSubmit: (f: CardFilterType) => void
}

export const GalleryCardFiltersFormBoolean = ({ cardFilter, onDelete, onSubmit }: Props) => {
  const { checked } = cardFilter
  const checkedError = useFilterFormError(!checked)
  const labels = CARD_FILTER_LABELS[cardFilter.slug]
  const label = labels.labelLong || labels.label

  const onCheck = () => {
    if (checked) onDelete()
    else onSubmit({ ...cardFilter, checked: !cardFilter.checked })
  }

  return (
    <div className={styles.container}>
      <div className={styles.checkbox}>
        <ButtonCheckbox
          borderColor={checkedError.warn ? 'warning' : undefined}
          onClick={onCheck}
          selected={checked}
          type='button'
          wiggle={checkedError.wiggle}
          wrap
        >
          {label}
        </ButtonCheckbox>
      </div>
    </div>
  )
}
